import { ColumnType, DynamicTableType } from '../../services/global/global-interfaces';

export const basePaths: Record<DynamicTableType, Record<ColumnType, string>> = {
  Device: {
    PROPERTY: '',
    DEVICE_ATTRIBUTE: '',
    COMPANY_ATTRIBUTE: 'location.managedBy',
    LOCATION_ATTRIBUTE: 'location',
    PRODUCT_ATTRIBUTE: '',
  },
  Location: {
    PROPERTY: '',
    DEVICE_ATTRIBUTE: '',
    COMPANY_ATTRIBUTE: 'managedBy',
    LOCATION_ATTRIBUTE: '',
    PRODUCT_ATTRIBUTE: '',
  },
  Company: {
    PROPERTY: '',
    DEVICE_ATTRIBUTE: '',
    COMPANY_ATTRIBUTE: '',
    LOCATION_ATTRIBUTE: '',
    PRODUCT_ATTRIBUTE: '',
  },
  Product: {
    PROPERTY: '',
    DEVICE_ATTRIBUTE: '',
    COMPANY_ATTRIBUTE: 'manufacturer',
    LOCATION_ATTRIBUTE: '',
    PRODUCT_ATTRIBUTE: '',
  },
} as const;
